import React from "react";
import { Star } from "@phosphor-icons/react";

export default function StarRating({ value = 0, count, size = 14, interactive = false, onChange }) {
  const rounded = Math.round(value * 2) / 2;
  return (
    <div className="inline-flex items-center gap-1.5">
      <div className="flex">
        {[1, 2, 3, 4, 5].map((i) => (
          <button
            key={i}
            type="button"
            disabled={!interactive}
            onClick={() => interactive && onChange?.(i)}
            className={interactive ? "cursor-pointer hover:scale-110 transition-transform" : "cursor-default"}
          >
            <Star
              size={size}
              weight={i <= rounded ? "fill" : "regular"}
              color={i <= rounded ? "#FFC900" : "#3a3a3a"}
            />
          </button>
        ))}
      </div>
      {(count !== undefined || value > 0) && (
        <span className="text-[11px] text-white/50 font-label">
          {value > 0 ? value.toFixed(1) : "New"}
          {count !== undefined && count > 0 ? ` · ${count}` : ""}
        </span>
      )}
    </div>
  );
}
